<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar>
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
<!--        <template #right>
          <van-icon name="chat-o" size="24" @click="toHomepage"/>
        </template>-->
      </van-nav-bar>
    </div>

    <div class="apply-body">
      <van-skeleton :loading="loading" :row="3" :style="{ paddingTop: '16px' }">
        <van-row justify="center">
          <van-col>
            <img :src="userInfo['headimgurl']" class="user-imgurl"/>
            <van-badge position="bottom-right" color="#1989fa" v-if="userInfo['flag'] >= 0">
              <div class="child" />
              <template #content>
                <van-icon name="manager-o" class="badge-icon" />
              </template>
            </van-badge>
          </van-col>
        </van-row>

        <van-row justify="center">
          <van-col>
            <span>{{ userInfo['nickname'] }}</span>
          </van-col>
        </van-row>

        <van-cell-group inset class="user-event" v-if="userInfo['flag'] === -1">
          <van-cell title="在线简历" @click="toResumeForm">
            <template #value>
              <van-icon name="arrow" />
            </template>
          </van-cell>
          <van-cell title="投递记录" @click="toResumeList">
            <template #value>
              <van-icon name="arrow" />
            </template>
          </van-cell>
        </van-cell-group>

        <van-cell-group inset class="user-event" v-if="userInfo['flag'] >= 0">
          <van-cell title="求职人员列表" @click="toUserList">
            <template #value>
              <van-icon name="arrow" />
            </template>
          </van-cell>
          <van-cell title="接收简历人员列表" @click="toUserAcceptList">
            <template #value>
              <van-icon name="arrow" />
            </template>
          </van-cell>
          <van-cell title="面试通过人员列表" @click="toUserPassList">
            <template #value>
              <van-icon name="arrow" />
            </template>
          </van-cell>
          <van-cell title="上传职位" @click="toJobUpload">
            <template #value>
              <van-icon name="arrow" />
            </template>
          </van-cell>
          <van-cell title="职位管理" @click="toJobManage">
            <template #value>
              <van-icon name="arrow" />
            </template>
          </van-cell>
          <van-cell title="数据看板" @click="toDataBoard">
            <template #value>
              <van-icon name="arrow" />
            </template>
          </van-cell>
          <van-cell title="人员管理" @click="toUserManage" v-if="userInfo['flag'] === 0">
            <template #value>
              <van-icon name="arrow" />
            </template>
          </van-cell>
          <van-cell title="系统设置" @click="toSystemConfig" v-if="userInfo['flag'] === 0">
            <template #value>
              <van-icon name="arrow" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-skeleton>
    </div>

  </div>
</template>

<script>
import {authorize, wxLogin} from "@/api";
import {Dialog} from "vant";
import {getUrlCode} from "@/api/common";

export default {
  name: "HomePage",
  data() {
    return {
      loading: true,
      userInfo: {},
    }
  },
  mounted() {
    this.loading = true;
    let code = getUrlCode().code;
    if (code === undefined || code === null) {
      let url = '';
      authorize().then(res => {
        url = res;
        window.location.replace(url);
      });
    } else {
      if (window.sessionStorage.getItem('userInfo') === null) {
        wxLogin('code=' + code).then(res => {
          if (res.code === 200) {
            window.sessionStorage.setItem('userInfo', JSON.stringify(res.data));
            window.sessionStorage.setItem('userResume', JSON.stringify(res.data['userResume']));
            this.userInfo = res.data;
            this.loading = false;
          } else {
            let data = res.data;
            Dialog.alert({
              title: '系统提示',
              message: res.msg,
              confirmButtonColor: '#1989fa',
              closeOnPopstate: false
            }).then(() => {
              if (data !== -1) {
                let url = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIxOTA5MzgzNg==&scene=110#wechat_redirect';
                window.location.replace(url);
              }
            }).catch(() => {
            });
          }
        });
      } else {
        this.userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
        this.loading = false;
      }
    }
  },
  methods: {
    goBack() {
      let back = window.sessionStorage.getItem('back');
      if (!back) {
        back = '/JobList';
      }
      this.$router.replace({path: back});
    },
    toHomepage() {
      this.$router.push({
        name: window.localStorage.getItem('home'),
        params: {
          uuid: window.localStorage.getItem('uuid')
        },
      });
    },
    toResumeForm() {
      this.$router.push('/ResumeForm');
    },
    toResumeList(){
      this.$router.push({
        name: 'ResumeList',
        params: {
          userId: this.userInfo['id']
        },
      });
    },
    toUserList() {
      this.$router.push('/UserList');
    },
    toUserAcceptList() {
      this.$router.push('/UserAcceptList');
    },
    toUserPassList() {
      this.$router.push('/UserPassList');
    },
    toJobUpload() {
      this.$router.push('/JobUpload');
    },
    toJobManage() {
      this.$router.push('/JobManageList');
    },
    toDataBoard() {
      this.$router.push('/DataBoard');
    },
    toUserManage() {
      this.$router.push('/UserManageList');
    },
    toSystemConfig() {
      this.$router.push('/SystemConfig');
    },

  }
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding: 0 16px 20px;
}

.user-imgurl {
  width: 4rem;
  height: 4rem;
  border-radius: 2rem;
}

.badge-icon {
  display: block;
  font-size: 10px;
  line-height: 16px;
}

.user-event {
  margin: 16px 0 0 0;
  border: 1px solid rgb(224, 224, 224);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(100, 101, 102, .12);
}

.van-row {
  padding-bottom: 12px;
}

/deep/ .van-hairline--bottom:after {
  border: none;
}
</style>